import { render, staticRenderFns } from "./AddPostmanCollectionSidePanel.vue?vue&type=template&id=a89570d6&"
import script from "./AddPostmanCollectionSidePanel.vue?vue&type=script&lang=ts&"
export * from "./AddPostmanCollectionSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports